import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import { config } from 'constants/firebase'

const firebaseApp = firebase.initializeApp(config)

export const getCurrentUser = () =>
  new Promise((resolve, reject) => {
    firebaseApp.auth().onAuthStateChanged(user => {
      if (user) {
        resolve(user)
      } else {
        reject('auth required')
      }
    })
  })

export const googleAuthProvider = new firebase.auth.GoogleAuthProvider()
export const twitterAuthProvider = new firebase.auth.TwitterAuthProvider()
export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider()
export const db = firebaseApp.database()
export const auth = firebaseApp.auth()
export const TIMESTAMP = firebase.database.ServerValue.TIMESTAMP
export default firebaseApp



// WEBPACK FOOTER //
// ./src/utils/firebase.js